var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonFlightSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.953644,
    width: 59.0927,
    height: 59.0927,
    rx: 17.3802,
    fill: "#C17B31"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84992,
    clipPath: "url(#clip0_239_28)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38.9457 11.2971H22.1331C16.0063 11.2971 12.5349 14.7684 12.5349 20.8952V37.6919C12.5349 43.8187 16.0063 47.29 22.1331 47.29H38.9457C45.0725 47.29 48.5278 43.8187 48.5278 37.6919V20.8952C48.5278 14.7684 45.0725 11.2971 38.9457 11.2971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9537 36L44.9537 38V36L39.9537 33.5V31C39.9537 30.7348 39.8483 30.4804 39.6608 30.2929C39.4732 30.1054 39.2189 30 38.9537 30C38.6885 30 38.4341 30.1054 38.2466 30.2929C38.059 30.4804 37.9537 30.7348 37.9537 31V33.5L32.9537 36V38L37.9537 36V39.5L35.9537 41V42L38.9537 41L41.9537 42V41L39.9537 39.5V36Z",
    fill: "#C17B31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9537 17H36.9537V15H34.9537V17H26.9537V15H24.9537V17H20.9537C20.4232 17 19.9145 17.2107 19.5395 17.5858C19.1644 17.9609 18.9537 18.4696 18.9537 19V39C18.9537 39.5304 19.1644 40.0391 19.5395 40.4142C19.9145 40.7893 20.4232 41 20.9537 41H30.9537V39H20.9537V19H24.9537V21H26.9537V19H34.9537V21H36.9537V19H40.9537V26H42.9537V19C42.9537 18.4696 42.743 17.9609 42.3679 17.5858C41.9928 17.2107 41.4841 17 40.9537 17Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.4985,
    height: 36.4985,
    fill: "white",
    transform: "translate(12.2507 11.2971)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonFlightSchedule);
export default __webpack_public_path__ + "static/media/carbon_flight-schedule.4e54fcea44b3d930f2a127c83cc8f434.svg";
export { ForwardRef as ReactComponent };